
import { Component, Mixins } from "vue-property-decorator";
import { IObjectStyleReadable } from "../../IObjectStyleReadable";

@Component({
})
export default class ForegroundSwitchableMixin extends Mixins() {
  editStyleReader?: IObjectStyleReadable;
  isFocused: boolean;

  get shouldDrawForeground(): boolean {
    const isForegroundEnabled = this.$configuration.style.document.editor.focusedObject.shouldDrawForeground || (this.editStyleReader && this.editStyleReader.isForegroundDrawingEnabled());
    return !!this.isFocused && isForegroundEnabled;
  }

  get foregroundStyleProperties() {
    // リッチテキストは指定する値の都合でオブジェクト側でz-indexを指定している
    return {
      zIndex: this.shouldDrawForeground ? 1 : null,
    };
  }
}
